import { motion } from 'framer-motion';
import type { SocialLink } from '../data/profile';
import { getIcon } from '../utils/iconMap';
import { getLinkTargetProps } from '../utils/links';

type SocialLinksProps = {
  links: SocialLink[];
};

export function SocialLinks({ links }: SocialLinksProps) {
  return (
    <motion.nav
      className="social-links"
      aria-label="Redes sociais"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.44, ease: 'easeOut' }}
    >
      {links.map((link) => {
        const Icon = getIcon(link.icon);

        return (
          <a key={link.id} href={link.href} aria-label={link.label} {...getLinkTargetProps(link.href)}>
            <Icon size={19} strokeWidth={1.8} />
          </a>
        );
      })}
    </motion.nav>
  );
}
